// extracted by mini-css-extract-plugin
export default {"container":"MyOrders_container__WGzNN","ordersContainer":"MyOrders_ordersContainer__OR9+z"};